module.exports = __webpack_public_path__ + "images/newerp_button1.1788773129009.png";